import { SupportedLocale, dateString } from "util/dates";
import { formatPurchaseAmount, formatDescription } from "../util/formatters";

import { Column } from "react-migration/components/TableDeprecated";
import { DescriptionCell } from "../../documents/components/DescriptionCell";
import { Transaction } from "../../typings/TransactionsResponse";
import { i18n } from "src/js/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { TransactionTypeCell } from "../../documents/components/TransactionTypeCell";

export const useDocumentColumns = () => {
  const { t } = useTranslation();

  return useMemo<Column<Transaction>[]>(
    () => [
      {
        label: t("dashboard.transactions.date"),
        render: ({ created }) => (created ? dateString(created, i18n.locale as SupportedLocale) : ""),
        grow: true,
      },
      {
        label: t("dashboard.transactions.user"),
        render: ({ user }) => (user?.firstname && user?.surname ? `${user.firstname} ${user.surname}` : "unknown user"),
        grow: true,
      },
      {
        label: t("dashboard.transactions.type"),
        render: (transaction) => <TransactionTypeCell transaction={transaction} />,
        grow: true,
      },
      {
        label: t("dashboard.transactions.balance_difference"),
        render: (transaction) => formatPurchaseAmount(transaction),
        grow: true,
        align: "right",
      },
      {
        label: t("dashboard.transactions.description"),
        render: (transaction) => <DescriptionCell transaction={transaction} formatDescription={formatDescription} />,
        grow: true,
      },
    ],
    [t]
  );
};
